import React, { useEffect, useState } from "react";
import { Check, Eye } from "lucide-react";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const WhatsappSelect = ({
  selectedWhatsappIds = [],
  onChange,
  viewAllWhatsappIds = [],
  onViewAllChange,
}) => {
  const [whatsapps, setWhatsapps] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/whatsapp");
        setWhatsapps(data);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  const toggle = (id) => {
    const isSelected = selectedWhatsappIds.includes(id);
    const next = isSelected
      ? selectedWhatsappIds.filter((w) => w !== id)
      : [...selectedWhatsappIds, id];
    onChange(next);
    // A connection that's no longer allowed can't keep "view all" either.
    if (isSelected && onViewAllChange && viewAllWhatsappIds.includes(id)) {
      onViewAllChange(viewAllWhatsappIds.filter((w) => w !== id));
    }
  };

  const toggleViewAll = (id) => {
    if (!onViewAllChange) return;
    const next = viewAllWhatsappIds.includes(id)
      ? viewAllWhatsappIds.filter((w) => w !== id)
      : [...viewAllWhatsappIds, id];
    onViewAllChange(next);
  };

  return (
    <div>
      <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-2">Conexiones Permitidas</label>
      <div className="flex flex-wrap gap-2 p-3 border border-slate-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 min-h-[48px]">
        {whatsapps.map((whatsapp) => {
          const selected = selectedWhatsappIds.includes(whatsapp.id);
          const viewAll = viewAllWhatsappIds.includes(whatsapp.id);
          return (
            <div
              key={whatsapp.id}
              className={`flex items-center rounded-lg text-xs font-semibold transition-all border overflow-hidden ${
                selected
                  ? "bg-indigo-600 text-white border-transparent"
                  : "text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-600 bg-transparent"
              }`}
            >
              <button
                type="button"
                onClick={() => toggle(whatsapp.id)}
                className="flex items-center gap-1.5 px-2.5 py-1 hover:opacity-80 transition-opacity"
              >
                {selected && <Check className="w-3 h-3" />}
                {whatsapp.name}
              </button>
              {selected && onViewAllChange && (
                <button
                  type="button"
                  onClick={() => toggleViewAll(whatsapp.id)}
                  title={
                    viewAll
                      ? "Ve todos los chats de esta conexión (clic para limitar a sus colas asignadas)"
                      : "Solo ve los chats de sus colas asignadas en esta conexión (clic para ver todos)"
                  }
                  className={`flex items-center px-1.5 py-1 border-l transition-colors ${
                    viewAll
                      ? "bg-white/20 border-white/30 text-white"
                      : "border-white/20 text-white/50 hover:text-white/90"
                  }`}
                >
                  <Eye className="w-3 h-3" />
                </button>
              )}
            </div>
          );
        })}
        {whatsapps.length === 0 && <p className="text-xs text-slate-400">No hay conexiones disponibles</p>}
      </div>
      {onViewAllChange && (
        <p className="text-xs text-slate-400 mt-1.5 flex items-center gap-1">
          <Eye className="w-3 h-3" /> Activa el ícono de ojo en una conexión para que este usuario vea todos sus chats, no solo los de sus colas asignadas.
        </p>
      )}
    </div>
  );
};

export default WhatsappSelect;
